import { default as minifyCssString } from 'minify-css-string'

const { useState, useEffect, useRef } = wp.element;
const { useSelect } = wp.data;

import { Flex, Icon, FlexBlock, SelectControl, __experimentalToggleGroupControl, __experimentalToggleGroupControlOptionIcon, TextControl, __experimentalUnitControl as UnitControl, FlexItem } from '@wordpress/components';

const generateCSS = (attributes, selector) => {
    let unit = 'px', value = '', cssHover = '', cssIcon = '', backgroundImage = '';

    const breakpoints = {
        desktop: 1024,
        tablet: 780,
        mobile: 640,
    };

    const cssRules = {
        desktop: '',
        tablet: '',
        mobile: '',
    };

    for (const key in attributes) {
        switch (key) {
            case 'padding':
            case 'margin':
                const sides = ['top', 'right', 'bottom', 'left'];

                for (const device in breakpoints) {
                    const deviceString = device === 'desktop' ? '' : `:${device}`;
                    const propertyData = attributes[key + deviceString];

                    if (!propertyData) {
                        continue;
                    }

                    sides.forEach(side => {
                        value = propertyData[side];
                        if (hasValue(value)) {
                            unit = cssCheckUnit(value, key);                                 // Sửa thêm ở đây, nếu có 4 giá trị thì ghi là padding luôn
                            cssRules[device] += `${key}-${side}: ${value}${unit};\n`;
                        }
                    });
                }

                break;

            case 'width':
            case 'min-width':
            case 'max-width':
            case 'height':
            case 'min-height':
            case 'max-height':
            case 'top':
            case 'right':
            case 'bottom':
            case 'left':
            case 'column-gap':
            case 'row-gap':
            case 'grid-gap':
            case 'grid-template-columns':
            case 'grid-template-rows':
            case 'grid-auto-rows':
            case 'grid-auto-flow':
            
                for (const device in breakpoints) {
                    const deviceString = device === 'desktop' ? '' : `:${device}`;
                    const value = attributes[key + deviceString];

                    if (!hasValue(value)) {
                        continue;
                    }

                    if (hasValue(value)) {
                        unit = cssCheckUnit(value, key);
                        cssRules[device] += `${key}: ${value}${unit};\n`;
                    }
                }

                break;

            case 'icon':
                cssIcon = getCssIcon(attributes, selector);
                break;
            case 'typography':

                for (const device in breakpoints) {
                    const deviceString = device === 'desktop' ? '' : `:${device}`;
                    const value = attributes[key + deviceString];

                    if (!hasValue(value)) {
                        continue;
                    }

                    const typographyCss = getTypographyCSS(value);
                    cssRules[device] += typographyCss;
                }

                break;
            case 'background-image':
                for (const device in breakpoints) {
                    const deviceString = device === 'desktop' ? '' : `:${device}`;
                    const value = attributes[key + deviceString];
                    if (!hasValue(value)) {
                        continue;
                    }
                    backgroundImage += getBackgroundImage(value);
                    cssRules[device] += backgroundImage;
                }
                break;
            case 'color':
            case 'background-color':
            case 'display':
            case 'flex-wrap':
            case 'align-self':
            case 'align-items':
            case 'justify-content':
            case 'flex-grow':
            case 'flex-shrink':
            case 'flex-basis':
            case 'order':
            case 'z-index':
            case 'font-weight':
            case 'isolation':
            case 'position':
            case 'visibility':
            case 'overflow':
            case 'opacity':
            case 'cursor':
            case 'pointer-events':
            case 'justify-items':
            case 'align-items':

                for (const device in breakpoints) {
                    const deviceString = device === 'desktop' ? '' : `:${device}`;
                    const value = attributes[key + deviceString];

                    if (!hasValue(value)) {
                        continue;
                    }

                    cssRules[device] += `${key}: ${value};\n`;
                }

                break;

            case 'flex-direction':

                for (const device in breakpoints) {
                    const deviceString = device === 'desktop' ? '' : `:${device}`;
                    const value = attributes[key + deviceString];

                    if (!hasValue(value)) {
                        continue;
                    }

                    let isReverse = value.isReverse ? true : false;
                    let direction = value.direction ? value.direction : false;

                    if (direction) {
                        const valueFlexDirection = isReverse ? `${direction}-reverse` : direction;
                        cssRules[device] += `${key}: ${valueFlexDirection};\n`;
                    }
                }

                break;

            case 'border':

                for (const device in breakpoints) {
                    const deviceString = device === 'desktop' ? '' : `:${device}`;
                    const value = attributes[key + deviceString];

                    if (!hasValue(value)) {
                        continue;
                    }

                    const borderCss = getBorderStyle(value);
                    cssRules[device] += borderCss.borderCss;

                    if (borderCss.hoverColor) {
                        cssHover += `#${selector}:hover {border-color: ${borderCss.hoverColor}}`;
                    }
                }

                break;

            default:

                break;
        }
    }

    let cssString = '';

    if (cssRules?.desktop) {
        cssString += `#${selector} {\n${cssRules.desktop}}\n`;
    }

    if (cssRules.tablet !== '') {
        cssString += `@media (max-width: ${breakpoints.tablet}px) {\n`;
        cssString += `#${selector} {\n${cssRules.tablet}}\n`;
        cssString += `}\n`;
    }

    if (cssRules.mobile !== '') {
        cssString += `@media (max-width: ${breakpoints.mobile}px) {\n`;
        cssString += `#${selector} {\n${cssRules.mobile}}\n`;
        cssString += `}\n`;
    }
    return minifyCssString(cssString + cssHover + cssIcon);
};

function cssCheckUnit(string, attribute) {
    if(['calc', 'auto', 'min-content', 'minmax', 'row', 'column']){
        return '';
    } else {
        let unit = string.slice(-3);
        for (const newUnit of ['px', '%', 'em', 'rem', 'vw', 'vh']) {
            if (unit.includes(newUnit) || ['line-height', 'letter-spacing'].includes(attribute)) {
                return '';
            }
        }
    }
    return 'px';
}

function hasValue(value) {
    if (value && typeof (value) != 'undefined') {
        return true;
    } else {
        return false;
    }
}

function getBackgroundImage(backgroundData) {
    let value, backgroundCss = '', size = '';

    for (const css in backgroundData) {
        value = backgroundData[css] ? backgroundData[css] : false;
        if (hasValue(value)) {
            switch (css) {
                case 'url':
                case 'external_url':
                    let shortcodePattern = /\{.*?\}/;
                    let isShortcode = shortcodePattern.test(value);
                    if(css == 'external_url' && isShortcode){
                        break;
                    }
                    backgroundCss += `background-image: url('${value}');`;
                    break;
                case 'blend-mode':
                case 'attachment':
                case 'repeat':
                    backgroundCss += `background-${css}: ${value};`;
                    break;
                case 'position':
                case 'size':
                    if(value == 'custom'){
                        if(css == 'position'){
                            let x = backgroundData?.positionX ? backgroundData?.positionX : '0%'
                            let y = backgroundData?.positionY ? ' ' + backgroundData?.positionY : ' 0%'
                            backgroundCss += `background-${css}: ${x}${y};`;
                        }else{
                            size = backgroundData?.sizeCustom ? backgroundData?.sizeCustom : false;
                            backgroundCss += size ? backgroundCss += `background-${css}: ${size};` : '';
                        }
                        
                    }else{
                        backgroundCss += `background-${css}: ${value};`;
                    }
                    break;
            }
        }
    }
    return backgroundCss;
}

function getTypographyCSS(typography) {
    let value, unit, typographyCss = '';

    for (const css in typography) {
        switch (css) {
            case 'font-size':
            case 'line-height':
            case 'letter-spacing':
            case 'text-align':
                value = typography?.[css];
                if (hasValue(value)) {
                    unit = cssCheckUnit(value, css);
                    unit = css == 'text-align' ? '' : unit;
                    typographyCss += `${css}: ${value}${unit};\n`;
                }
                break;
            case 'font-weight':
            case 'text-transform':
            case 'text-decoration':
            case 'font-style':
            case 'color':
                value = typography?.[css];
                if (hasValue(value)) {
                    typographyCss += `${css}: ${value};\n`;
                }
                break;
        }
    }

    return typographyCss;
}

function getBorderStyle(border) {
    let borderCss = '';

    function addCSSProperty(property, value, unit) {
        if (value !== '' && typeof (value) != 'undefined') {
            return `${property}: ${value}${unit};`;
        }
        return '';
    }

    const width = border.width;
    const widthUnit = border.width?.unit ? border?.width?.unit : 'px';

    const radius = border.radius;
    const radiusUnit = border.radius?.unit ? border?.radius?.unit : 'px';

    const style = border.style;
    const color = border.color;
    const hoverColor = border.hoverColor;

    if (style && style != 'none' && typeof (style) != 'undefined') {
        if (width) {
            borderCss += `
            ${addCSSProperty('border-style', style, '')}
            ${addCSSProperty('border-color', color, '')}
            ${addCSSProperty('border-top-width', width.top, widthUnit)}
            ${addCSSProperty('border-right-width', width.right, widthUnit)}
            ${addCSSProperty('border-bottom-width', width.bottom, widthUnit)}
            ${addCSSProperty('border-left-width', width.left, widthUnit)}`;
        }
    }

    if (radius) {
        borderCss += `
        ${addCSSProperty('border-top-left-radius', radius.top, radiusUnit)}
        ${addCSSProperty('border-top-right-radius', radius.right, radiusUnit)}
        ${addCSSProperty('border-bottom-right-radius', radius.bottom, radiusUnit)}
        ${addCSSProperty('border-bottom-left-radius', radius.left, radiusUnit)}`;
    }

    return {
        borderCss: borderCss,
        hoverColor: hoverColor
    };
}

//Save css file
wp.domReady(function () {
    let ajaxCalled = false;
    wp.data.subscribe(() => {
        const currentEditor = wp.data.select('core/editor');
        const currentPostId = currentEditor.getCurrentPostId();
        let css = '';
        const isSavingPost = wp.data.select('core/editor').isSavingPost();
        const isAutosavingPost = wp.data.select('core/editor').isAutosavingPost();
        //const isEditedPostDirty = currentEditor.isEditedPostDirty();
        //console.log('isEditedPostDirty', isEditedPostDirty);
        if (isSavingPost && !isAutosavingPost) {
            ajaxCalled = true;
            const blocks = currentEditor.getBlocks();
            blocks.forEach(block => {
                if (block.name.includes('softlite-io-integration')) {
                    css += getCssBlock(block);
                }
            });
            if (css) {
                const data = new FormData();
                data.append('action', 'softlite_save_css');
                data.append('css', css);
                data.append('post_id', currentPostId);
                fetch(softliteData.ajaxurl, {
                    method: 'POST',
                    body: data,
                })
                    .then(() => {
                        setTimeout(() => {
                            ajaxCalled = false
                        }, 1000)
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        setTimeout(() => {
                            ajaxCalled = false
                        }, 1000)
                    });
            }
        }
    });

    function getCssBlock(block) {
        let attributes = block?.attributes;
        let cssBlock = attributes?.css ? attributes?.css : '';
        let cssCustomString = '';

        cssCustomString = getCssCustomBlock(attributes);
        cssBlock = cssBlock + cssCustomString;

        if (block?.innerBlocks && block?.innerBlocks.length) {
            block?.innerBlocks.forEach(newBlock => {
                cssBlock += getCssBlock(newBlock)
            });
        }
        return minifyCssString(cssBlock);
    }
});

const getCssCustomBlock = (attributes) => {
    let cssString = '';
    const id = attributes.id;
    const breakpoints = {
        desktop: 1024,
        mobile: 360,
        tablet: 780
    };

    for (const breakpoint in breakpoints) {
        const deviceString = breakpoint === 'desktop' ? '' : `:${breakpoint}`;
        if (attributes['cssCustom' + deviceString]) {
            if (breakpoint === 'desktop') {
                cssString += minifyCssString(attributes['cssCustom' + deviceString]).replaceAll('%root%', `#softlite-block-${id}`);
            } else {
                cssString += `@media (max-width: ${breakpoints[breakpoint]}px) {`;
                cssString += minifyCssString(attributes['cssCustom' + deviceString]).replaceAll('%root%', `#softlite-block-${id}`);
                cssString += `}`;
            }
        }
    }

    return minifyCssString(cssString);
}

const setAttributesResponsive = (attribute, value, device, setAttributes, attributes) => {
    const deviceString = device === 'desktop' ? '' : `:${device}`;
    const parentAttribute = attribute.split('.')[0];
    const attributeWithDevice = `${parentAttribute}${deviceString}`;

    if (value !== '') {
        if (attribute.split('.').length === 1) {
            setAttributes({
                [attributeWithDevice]: value
            });
        } else {
            const attributeValue = {
                ...attributes[attributeWithDevice]
            };

            // get right of the first dot
            const rightPath = attribute.split('.').slice(1).join('.');

            setAttributes({
                ...attributeWithDevice, [attributeWithDevice]: createObject(rightPath, value, attributeValue)
            });
        }
    } else {
        if (attribute.split('.').length === 1) {
            const newAttributes = { ...attributes };
            newAttributes[attributeWithDevice] = '';
            setAttributes(newAttributes);
        } else {
            const attributeValue = {
                ...attributes[attributeWithDevice]
            };

            // get right of the first dot
            const rightPath = attribute.split('.').slice(1).join('.');

            removeKey(rightPath, attributeValue);

            setAttributes({
                [attributeWithDevice]: attributeValue
            });
        }
    }

};

const createObject = (path, value, obj) => {
    const keys = path.split('.');
    const lastKey = keys.pop();

    let currentObj = obj;

    keys.forEach((key) => {
        if (!currentObj[key]) {
            currentObj[key] = {};
        }
        currentObj = currentObj[key];
    });

    if (lastKey) {
        currentObj[lastKey] = value;
    }

    return obj;
}

function removeKey(path, obj) {
    const keys = path.split('.');
    let current = obj;

    for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) {
            return; // If the path does not exist, do nothing
        }
        current = current[keys[i]];
    }

    delete current[keys[keys.length - 1]];
}

function getValueByPath(path, obj, defaultValue = null) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj) ?? defaultValue;
}

function addAttributeResponsive(attributes) {
    const newAttributes = { ...attributes };
    Object.keys(attributes).forEach(key => {
        if (key !== 'state') {
            newAttributes[key + ':tablet'] = attributes[key];
            newAttributes[key + ':mobile'] = attributes[key];
        }
    });
    return newAttributes;
}

function getCssIcon(attributes, selector) {
    let cssIcon = '', cssIconTablet = '', cssIconMobile = '';
    let cssRules = {
        desktop: '',
        tablet: '',
        mobile: ''
    }
    const breakpoints = {
        desktop: 1024,
        tablet: 780,
        mobile: 640,
    };
    for (const device in breakpoints) {
        const deviceString = device === 'desktop' ? '' : `:${device}`;

        for (const style in attributes?.icon) {
            const value = attributes?.[`icon${deviceString}`]?.[style];
            if (hasValue(value)) {
                switch (style) {
                    case 'rotate':
                        cssRules[device] += `${style}: ${value}DEG;\n`;
                        break
                    case 'size':
                            cssRules[device] += `width: ${value}px;height:${value}px;`;
                        break;
                    case 'spacing':
                            let position = attributes?.[`icon${deviceString}`]?.position ?  attributes?.[`icon${deviceString}`]?.position : 'before';
                            let type = position === 'before' ? 'margin-left' : 'margin-right';
                            cssRules[device] += `${type}: ${value}px;`;
                        break;
                    case 'color':
                            cssRules[device] += `${style}: ${value};`;
                        break;
                }
            }

        }
    }

    if (cssRules.desktop !== '') {
        cssIcon += cssRules.desktop;
    }

    if (cssRules.tablet !== '') {
        cssIconTablet = `@media (max-width: 780px) {#${selector} svg{${cssRules.tablet}}}`;
    }
    if (cssRules.mobile !== '') {
        cssIconMobile = `@media (max-width: 360px) {#${selector} svg{${cssRules.mobile}}}`;
    }
    cssIcon = cssIcon !== '' ? `#${selector} svg{${cssIcon}}` : '';
    return cssIcon + cssIconTablet + cssIconMobile;
}
function getCustomAttribute(attributesArray) {
    return attributesArray.reduce((attrs, item) => {
        if (item.name && item.name !== 'id') {
            attrs[item.name] = item.value || '';
        }
        return attrs;
    }, {});
}

function replaceBackgroundImage(css, site_url) {
    const regexURLCss = /url\((.*?)\)/g;
    const files = css.match(regexURLCss);
    
    if (files && files.length > 0) {
        files.forEach(file => {
            if (!file.includes('data:') && !file.includes('http')) {
                const fileURL = file.includes("'") ? file.split("url('")[1].split("')")[0] : file.split("url(")[1].split(")")[0];
                const regexURL = file.includes("'") ? `url\\('${fileURL}'\\)` : `url\\(${fileURL}\\)`;
                css = css.replace(new RegExp(regexURL, 'g'), `url(${site_url + fileURL})`);
            }
        });
    }
    return css;
}

export { generateCSS, getCssCustomBlock, setAttributesResponsive, getValueByPath, addAttributeResponsive, getCustomAttribute, replaceBackgroundImage }
